import React, { useState } from "react";
import PropTypes from "prop-types";
import { domain } from "../../assets/js/api";

function Popup({ isOpen, onClose, images = [] }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const handleClose = () => {
        setCurrentIndex(0);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal is-active">
            <div className="modal-background" onClick={handleClose}></div>
            <div className="modal-content">
                {images.length > 0 ? (
                    <figure className="image-container">
                        <div className="image-wrapper">
                            <img
                                src={domain + images[currentIndex].image}
                                alt={`Documentación ${currentIndex + 1}`}
                            />
                            <div className="image-navigation">
                                <button className="arrow left" onClick={prevImage}>&#8592;</button>
                                <button className="arrow right" onClick={nextImage}>&#8594;</button>
                            </div>
                        </div>
                        {images[currentIndex].footprint && (
                            <figcaption className="figcaption">
                                {images[currentIndex].footprint}
                            </figcaption>
                        )}
                    </figure>
                ) : (
                    <p>No hay imágenes disponibles.</p>
                )}
            </div>
            <button className="modal-close is-large" aria-label="close" onClick={handleClose}></button>
        </div>
    );
}

Popup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    images: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string.isRequired,
            footprint: PropTypes.string,
        })
    ).isRequired,
};

export default Popup;
